export default "__VITE_ASSET__CrFLdt4F__"